var capitalizeFirstLetter = function(text) {
    if (text.length === 0) return '';
    return "".concat(text[0].toUpperCase()).concat(text.slice(1));
};

export { capitalizeFirstLetter };
